module.exports = __webpack_public_path__ + "img/jd.481c1eba.png";